interface VerifiedBlueIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const VerifiedBlueIcon: React.FC<VerifiedBlueIconProps> = ({
  width = 14,
  height = 14,
  className = '',
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 14 14" 
      fill="none"
      className={className}
    >
      <path 
        d="M7 1.75C9.89947 1.75 12.25 4.1005 12.25 7C12.25 9.89947 9.89947 12.25 7 12.25C4.1005 12.25 1.75 9.89947 1.75 7C1.75 4.1005 4.1005 1.75 7 1.75Z" 
        fill="#50B0F8"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M9.35119 5.43673C9.52204 5.60759 9.52204 5.8846 9.35119 6.05545L6.49286 8.91379C6.322 9.08464 6.04499 9.08464 5.87414 8.91379L4.64914 7.68879C4.47828 7.51793 4.47828 7.24092 4.64914 7.07007C4.81999 6.89921 5.097 6.89921 5.26786 7.07007L6.1835 7.98571L8.73247 5.43673C8.90333 5.26588 9.18033 5.26588 9.35119 5.43673Z" 
        fill="white"
      />
    </svg>
  );
};

export default VerifiedBlueIcon;